import { useState } from "react";
import "./Header.css";
import logo from "../assets/kemarilogohero.png";
import { useLocation, useNavigate } from "react-router-dom";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollTo = (id) => {
    setMenuOpen(false);
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="header">
      <div className="logo">
        <img src={logo} alt="Kemari Technology Corporation" />
      </div>

      {/* Desktop nav */}
      <nav className="nav">
        <button onClick={() => scrollTo("about")}>About</button>
        <button onClick={() => scrollTo("team")}>Team</button>
        <button onClick={() => scrollTo("contact")}>Contact</button>
      </nav>

      {/* Burger button — mobile only */}
      <button
        className={`burger ${menuOpen ? "burger--open" : ""}`}
        onClick={() => setMenuOpen((p) => !p)}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
      >
        <span />
        <span />
        <span />
      </button>

      {/* Mobile drawer */}
      <div className={`mobile-menu ${menuOpen ? "mobile-menu--open" : ""}`}>
        <button onClick={() => scrollTo("about")}>About</button>
        <button onClick={() => scrollTo("team")}>Team</button>
        <button onClick={() => scrollTo("contact")}>Contact</button>
      </div>
    </header>
  );
}

export default Header;